import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Image } from '../../../commonComponents';
import { language } from 'Root/constants';
import Context from '../../../context';

const images = {
  defineLogo: require('../../../../assets/imgs/new/logo.png'),
};

const Title = ({
  lenses,
  lookInfo,
  recommendedLens,
  download,
  showPdfTitle,
}) => {
  const { lensGuid, lensCleared } = useContext(Context);
  const lensSelected = lenses.findIndex((lens) => lens.guid === lensGuid);
  const isDefaultLens =
    recommendedLens > -1 && lensSelected == recommendedLens && true;
  const lensClearedCondition =
    recommendedLens < 0 && !download && lensCleared && lookInfo.lensOrder > -1;
  return (
    <>
      <div className="md-text-medium text-center text-uppercase selected my-2">
        <span className="define-logo">
          <Image
            src={images.defineLogo}
            className="img-responsive"
            alt="Define Logo"
          />
        </span>
        <span className="ml-4">
          <FormattedMessage
            id="looks.you_have_chosen"
            defaultMessage="You have chosen:"
          />
          <span className="text-golden ml-2 name">
            {lookInfo[language]['name']}
          </span>
        </span>
        <span className="ml-5">
          {lensSelected > -1 && !lensCleared && (
            <React.Fragment>
              <FormattedMessage
                id="looks.with_lens"
                defaultMessage="With Lens:"
              />
              <span className="text-golden ml-2 name">
                {lenses[lensSelected]['name']}
              </span>
            </React.Fragment>
          )}
        </span>
      </div>
      {!isDefaultLens && recommendedLens > -1 && !download && (
        <div
          className={`text-small text-center text-uppercase default mb-4 ${
            showPdfTitle ? 'opaque' : 'visible'
          }`}
        >
          <span className="mr-1 name">{lookInfo[language]['name']}</span>
          <FormattedMessage
            id="looks.best_suited"
            defaultMessage="look is best suited with"
          />
          <span className="ml-1 name">
            {lensClearedCondition
              ? lenses[lookInfo.lensOrder]['name']
              : lenses[recommendedLens]['name']}
          </span>
        </div>
      )}
    </>
  );
};

Title.PpopTypes = {
  lookInfo: PropTypes.string,
  lenses: PropTypes.object,
  recommendedLens: PropTypes.number,
  download: PropTypes.bool,
  showPdfTitle: PropTypes.bool,
};

export default Title;
